module.exports = __webpack_public_path__ + "Patetrn.f3fbd0c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg-icons/Patetrn.svg
// module id = 254
// module chunks = 1